import radioButton from './componentIcons/icon-radio-button.svg';
import radioButtonLarge from './componentIcons/icon-radio-button-large.svg';
import toggle from './componentIcons/icon-toggle.svg';
import preloader from './componentIcons/icon-preloader.svg';

export type ComponentIconKeys = keyof typeof componentIcons;

export const componentIcons = {
  radioButton,
  radioButtonLarge,
  toggle,
  preloader
};
